import { get } from "http";
import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";


export function useRecommendationApi() {
  const callApi = useApiCall();

  const getRecommendationList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.RECOMMENDATION.RECOMMENDATION_LIST, data, onSuccess, onError);
  }

  return {
    getRecommendationList,
  };
}
